import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Output,
} from '@angular/core';

require('./save-footer.scss');
@Component({
  standalone: false,
  selector: 'app-save-footer',
  templateUrl: './save-footer.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveFooterComponent {

  @Output() onSave = new EventEmitter<null>();
  @Output() onCancel = new EventEmitter<null>();

}
